"use client";

import { isChannel } from "@website/utils/channel/helpers";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { useSyncExternalStore } from "react";
type ChatbotVisibility = boolean | null;
type ChatbotVisibilityListener = () => void;
let chatbotVisibilitySnapshot: ChatbotVisibility = null;
const chatbotVisibilityListeners = new Set<ChatbotVisibilityListener>();
export const getChatbotVisibilityState = () => !isChannel(["b2b", "telesale"]) && ExperimentSDK.isOn("chatbot_display");
const getChatbotVisibilitySnapshot = () => chatbotVisibilitySnapshot;
const getServerChatbotVisibilitySnapshot = () => null;
const subscribeToChatbotVisibility = (listener: ChatbotVisibilityListener) => {
  const nextSnapshot = getChatbotVisibilityState();
  if (nextSnapshot !== chatbotVisibilitySnapshot) {
    chatbotVisibilitySnapshot = nextSnapshot;
    for (const currentListener of chatbotVisibilityListeners) {
      currentListener();
    }
  }
  chatbotVisibilityListeners.add(listener);
  return () => {
    chatbotVisibilityListeners.delete(listener);
    if (chatbotVisibilityListeners.size === 0) {
      chatbotVisibilitySnapshot = null;
    }
  };
};
export const useChatbotVisibility = () => {
  return useSyncExternalStore(subscribeToChatbotVisibility, getChatbotVisibilitySnapshot, getServerChatbotVisibilitySnapshot);
};